// Defines which sub-module tabs each role can actively use
// 'active' = can see and interact
// 'grayed' = visible but disabled
export type TabAccess = 'active' | 'grayed';
export const TAB_ACCESS: Record<string, Record<string, Record<string, TabAccess>>> = {
  finance: {
    dashboard:    { OFFICIER: 'grayed', COMMISSAIRE: 'grayed', DG: 'active', SUPER_ADMIN: 'active' },
    intelligence: { OFFICIER: 'grayed', COMMISSAIRE: 'grayed', DG: 'active', SUPER_ADMIN: 'active' },
    form:         { OFFICIER: 'active', COMMISSAIRE: 'grayed', DG: 'grayed', SUPER_ADMIN: 'active' },
    advanced:     { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
  },
  hr: {
    dashboard:    { OFFICIER: 'grayed', COMMISSAIRE: 'grayed', DG: 'active', SUPER_ADMIN: 'active' },
    intelligence: { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
    form:         { OFFICIER: 'active', COMMISSAIRE: 'grayed', DG: 'grayed', SUPER_ADMIN: 'active' },
    advanced:     { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
  },
  operations: {
    dashboard:           { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
    report:              { OFFICIER: 'active', COMMISSAIRE: 'grayed', DG: 'grayed', SUPER_ADMIN: 'active' },
    incidents:           { OFFICIER: 'active', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
    history:             { OFFICIER: 'active', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
    smartvision:         { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
    incidents_analytics: { OFFICIER: 'active', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
  },
  logistique: {
    intelligence: { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
    advanced:     { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
    dashboard:    { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
    assets:       { OFFICIER: 'active', COMMISSAIRE: 'active', DG: 'grayed', SUPER_ADMIN: 'active' },
    history:      { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
    gestion:      { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
  },
  formation: {
    analytics: { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
    dashboard: { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
    form:      { OFFICIER: 'active', COMMISSAIRE: 'grayed', DG: 'grayed', SUPER_ADMIN: 'active' },
    advanced:  { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
  },
  executive: {
    dashboard: { OFFICIER: 'grayed', COMMISSAIRE: 'grayed', DG: 'active', SUPER_ADMIN: 'active' },
  },
  reporting: {
    institutional: { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
  },
  lean: {
    analytics: { OFFICIER: 'grayed', COMMISSAIRE: 'active', DG: 'active', SUPER_ADMIN: 'active' },
    dashboard: { OFFICIER: 'grayed', COMMISSAIRE: 'grayed', DG: 'active', SUPER_ADMIN: 'active' },
    form:      { OFFICIER: 'active', COMMISSAIRE: 'grayed', DG: 'grayed', SUPER_ADMIN: 'active' },
  },
};
export const getTabAccess = (module: string, tab: string, role: string): TabAccess => {
  return TAB_ACCESS[module]?.[tab]?.[role] ?? 'grayed';
};
export const getDefaultTab = (module: string, role: string): string => {
  const tabs = TAB_ACCESS[module];
  if (!tabs) return Object.keys(TAB_ACCESS[module] || {})[0] || '';
  const first = Object.entries(tabs).find(([, roles]) => roles[role] === 'active');
  return first ? first[0] : Object.keys(tabs)[0];
};
